module.exports = __webpack_public_path__ + "static/img/2.c686edc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/contact/eng/2.png
// module id = KTUZ
// module chunks = 0